import {
    Create,
    TextInput,
    SimpleForm,
    minValue,
    SelectInput,
    required,
    NumberInput,
    AutocompleteInput,
    useDataProvider,
    BooleanInput,
} from 'react-admin';
import FileUpload from '../../common/inputs/FileUpload';
import { BANNER_TYPE } from '../../common/constants';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
export const BannerCategoryRender = (choice: any) => `${choice.name}`;

const BannerCreate = () => {
    const [searchParams] = useSearchParams();
    const categoryId = searchParams.get('categoryId');
    const isDisabled = !!categoryId;
    const dataProvider = useDataProvider();

    const [bannerCategory, setBannerCategory] = useState([]) as any;

    useEffect(() => {
        dataProvider
            .getList('banner-categories', {
                pagination: { page: 1, perPage: 100 },
                sort: { field: 'name', order: 'ASC' },
                filter: {},
            })
            .then(({ data }) => setBannerCategory(data))
            .catch(error => console.error(error));
    }, [dataProvider]);
    return (
        <Create redirect={'/banners'}>
            <SimpleForm
                defaultValues={{
                    categoryId: categoryId,
                }}
            >
                <FileUpload
                    type="VIDEO_THUMBNAIL"
                    source="image"
                    required={true}
                    accept={'image/*'}
                />
                <BooleanInput
                    source="hidden"
                    fullWidth
                    label="Hidden"
                />                
                <NumberInput
                    source="displayOrder"
                    fullWidth
                    validate={[required(), minValue(1)]}
                />
                <TextInput source="redirect_url" fullWidth validate={[required()]} />
                <SelectInput
                    source="type"
                    label={'Type'}
                    fullWidth
                    validate={[required()]}
                    choices={BANNER_TYPE}
                />
                <AutocompleteInput
                    source="categoryId"
                    choices={bannerCategory}
                    optionText={BannerCategoryRender}
                    fullWidth
                    disabled={isDisabled}
                    validate={[required()]}
                />
            </SimpleForm>
        </Create>
    );
};

export default BannerCreate;
